import Modal from './components/Modal.svelte'
import { start, track, getDebug, cancelTask, markAsCompleted, createClient } from './track/index'
import { delay } from 'puffy-core/time'

const RETRY = 'retry'
const MAX_RETRY = 20
const TIME_BETWEEN_RETRY_IN_MS = 1000

/**
 * Converts a single node string to an HTML DOM element
 * 
 * @param	{String}	HTML representing a single element
 * 
 * @return	{Element}
 */
const htmlToElement = html => {
	try {
		var template = document.createElement('template')
		html = html.trim() // Never return a text node of whitespace as the result
		template.innerHTML = html
		return template.content.firstChild
	} catch (err) {
		console.error(`Failed to parse the DOM string a DOM element. DOM string: ${html}`)
		console.error(err.stack || err.message)
	}
}

const syncLoader = ({ cssSelector, apiKey, elStr }) => {
	try {
		const debug = getDebug()
		
		const target = document.querySelector(cssSelector)
		if (!target) {
			console.error(`ERROR - 'target' attribute '${cssSelector}' not found.`)
			return RETRY
		}

		const client = createClient(apiKey)

		let node = target
		if (elStr) {
			const el = htmlToElement(elStr)
			if (el) {
				target.parentNode.replaceChild(el, target)
				node = el
			}
		}
		
		const modal = new Modal({
			target: document.body
		})

		modal.$on('close', () => {
			modal.$set({ open:false, sucessMsg:'' })
		})

		modal.$on('canceltask', () => {
			if (debug)
				console.log('INFO - Cancelling current task...')
			cancelTask()
			modal.$set({ open:false, sucessMsg:'' })
		})

		modal.$on('claimreward', async () => {
			if (debug)
				console.log('INFO - Claiming reward...')
			modal.$set({ loading:true })
			const resp = await markAsCompleted(client)
			if (resp && resp.error)
				modal.$set({ error:resp.error, loading:false })	
			else {
				// Show success message
				modal.$set({ 
					sucessMsg: 'Reward successfully claimed.',
					loading: false
				})
				setTimeout(() => {
					modal.$set({ open:false, sucessMsg:'', loading:false })
				}, 2000)
			}
		})
		
		// browse, click, enter_code, find, form_completion, intro, keywords_search, mark_as_completed, read, scroll, wait
		modal.$on('submitcode', async ({ detail:data }) => {
			const code = (data||{}).code
			if (code) {
				modal.$set({ loading:true })
				if (debug)
					console.log('INFO - Staring the task...')
				const { error } = await start(code, client, debug)
				if (error)
					modal.$set({ error, loading:false })	
				else {
					// Show success message
					modal.$set({ 
						sucessMsg: 'Valid code submitted.</br>Your task starts now.',
						loading: false
					})
					
					// Start the tracking
					track()
					// Close the modal within 2 sec
					setTimeout(() => {
						modal.$set({ open:false, sucessMsg:'' })
					}, 2000)
				}
			}
		})

		node.addEventListener('click', () => {
			modal.$set({ open:true, sucessMsg:'', error:'' })
		})

		window.uxm_context = track()

		if (debug)
			console.log('INFO - UXM Magic JS tracker successfully attached')

		return modal
	} catch(err) {
		console.error(`ERROR - Failed to create the UX magic plugin. Details: ${err.stack||err.message}`)
	}
}

const asyncLoader = async ({ cssSelector, apiKey, elStr }) => {
	const debug = getDebug()
	let resp = syncLoader({ cssSelector, apiKey, elStr })
	let retry_counter = 0
	while (resp == RETRY && retry_counter < MAX_RETRY) {
		if (debug)
			console.log('INFO - Page may not be ready yet. Waiting 1 second before retrying to attach UXM Magic JS tracker...')
		await delay(TIME_BETWEEN_RETRY_IN_MS)
		resp = syncLoader({ cssSelector, apiKey, elStr })
		retry_counter++
	}
	if (resp == RETRY)
		if (debug) {
			console.error(`ERROR - Max retry attempts (${MAX_RETRY}) exceeded`)
			return null
		} else
			return resp
}

const Loader = function() {
	if (!document.currentScript) {
		console.error('ERROR - document.currentScript is undefined')
		return
	}
	
	// Gets the script tag's attributes
	const cssSelector = document.currentScript.getAttribute('target')
	const apiKey = document.currentScript.getAttribute('apikey')
	const elStr = document.currentScript.getAttribute('el')

	if (!cssSelector) {
		console.error('ERROR - Missing required \'target\' attribute on the uxmagic script.')
		return
	}
	if (!apiKey) {
		console.error('ERROR - Missing required \'apikey\' attribute on the uxmagic script.')
		return
	}
	
	return asyncLoader({ cssSelector, apiKey, elStr })
}

const loader = new Loader()

export default loader